"use client";
import React from "react";

// You can also move this to a separate file like `ReadMoreList.jsx`
// function ReadMoreList({ items = [], maxItems = 3, icon = "✅" }) {
//   const [showAll, setShowAll] = React.useState(false);
//   const visibleItems = showAll ? items : items.slice(0, maxItems);

//   return (
//     <>
//       <ul className="list-disc pl-6 space-y-2 text-base text-gray-800">
//         {visibleItems.map((point, idx) => {
//           const [boldPart, ...rest] = point.title.split(":");
//           const normalPart = rest.join(":").trim();

//           return (
//             <div key={idx} className="flex items-start gap-3">
//               <span className="text-green-600 text-xl">{icon}</span>
//               <p>
//                 <strong>{boldPart}:</strong> {normalPart}
//               </p>
//             </div>
//           );
//         })}
//       </ul>

//       {items.length > maxItems && (
//         <div className="flex justify-center mt-4">
//           <button
//             onClick={() => setShowAll(!showAll)}
//             className="text-[#0096AA] underline"
//           >
//             {showAll ? "Read Less" : "Read More"}
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

export default function WhyChooseThisCourses({ courseReasons = {} }) {
  const { heading, subheading, points = [] } = courseReasons;

  return (
    <div className="mb-6">
      <h2 className="text-3xl font-bold mb-3">{heading}</h2>

      {subheading && (
        <p className="mb-6 text-lg text-gray-700">{subheading}</p>
      )}

      {/* <ReadMoreList items={points} maxItems={3} /> */}
    </div>
  );
}
